import {Validator} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowValidationController';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {InputEdit} from '@mintdata/mint-kit/impl/properties/components/inputEdit/InputEdit';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import _get from 'lodash/get';

@observer
export class NumericInputWidget extends React.Component<IWidgetComponentProps, any>
{
    @observable
    private isDirty:boolean;

    public static defaultProps:Partial<IWidgetComponentProps> = {
        isOutlined: true,
    };

    constructor(props:IWidgetComponentProps)
    {
        super(props);

        const {isDirty} = props;

        this.isDirty = (isDirty !== undefined) ? isDirty : false;
    }

    @action
    componentWillReceiveProps({isDirty}:IWidgetComponentProps)
    {
        if( isDirty !== undefined )
        {
            this.isDirty = isDirty;
        }
    }

    @action.bound
    private _onChange(e:React.FormEvent<any>)
    {
        const {onChange, isDirty} = this.props;
        const {value} = e.target as any;

        const numberValue = Number(value);
        const asNumber = !Validator.isNumber(value) ? value : numberValue;

        onChange(asNumber);

        if( isDirty === undefined )
        {
            this.isDirty = true;
        }
    }

    @action.bound
    private _onKeyDown(e:React.KeyboardEvent<any>)
    {
        const {prop, onChange, isDirty} = this.props;
        const value = Number(prop.value);

        if( e.keyCode === 38 )
        {
            let newValue = value + 1;
            newValue = Number.isNaN(newValue) ? 1 : newValue;
            onChange(newValue);

            if( isDirty === undefined )
            {
                this.isDirty = true;
            }

            e.preventDefault();
        }

        if( e.keyCode === 40 )
        {
            let newValue = value - 1;

            if( newValue < 0 ) return;

            newValue = Number.isNaN(newValue) ? 1 : newValue;
            onChange(newValue);

            if( isDirty === undefined )
            {
                this.isDirty = true;
            }

            e.preventDefault();
        }
    }

    render()
    {
        const {
            prop,
            inlineLabel,
            isOutlined,
            error,
            onRef,
        } = this.props;

        const {value} = prop;
        const errors = this.isDirty ? _get(error, 'messages', []) : [];

        return (
            <div>
                <InputEdit
                    autoComplete={'none'}
                    label={inlineLabel}
                    value={value == null ? '' : value}
                    isOutlined={isOutlined}
                    isInvalid={errors.length > 0}
                    validationError={errors[0]}
                    onChange={this._onChange}
                    onKeyDown={this._onKeyDown}
                    onRef={onRef}
                />
            </div>
        );
    }
}
